// extracted by mini-css-extract-plugin
module.exports = {"root":"Carousel_root__7zE3n","slide":"Carousel_slide__eZEFp","indicator":"Carousel_indicator__BvLh0"};